import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateAvatarRequest extends BaseUpdateRequest {
    fileName: string;
}